export enum DeepLinkModules {
	EMPLOYEE_DATA_EMPLOYEE_MASTER_DATA = "employee-data-employee-master-data",
	EMPLOYEE_DATA_PAYGROUP_MASTER_DATA = "employee-data-paygroup-master-data",
	CUSTOMER_EDIT = "customer-edit",
	LEGAL_ENTITY_EDIT = "legal-entity-edit",
	PAYGROUP_EDIT = "paygroup-edit",
	LEGAL_ENTITY_LIST = "legal-entity-list",
	PAYGROUP_LIST = "paygroup-list",
	DASHBOARD = "dashboard",
	GLOBAL_DASHBOARD = "global-dashboard",
	PAY_GROUPS = "pay-groups",
	PAYMENT_CALENDAR = "payment-calendar",
	USER_MANAGEMENT = "user-management",
	BANK_ACCOUNTS = "bank-accounts",
	SERVICE_DEFINITION = "service-definition",
	REPORTING = "reporting",
	GLOBAL_DASHBOARD_FILE_HISTORY = "global-dashboard-file-history",
	GLOBAL_DASHBOARD_PAYOUTS = "global-dashboard-payouts",
	GLOBAL_DASHBOARD_FUNDING_DATE = "global-dashboard-funding-date",
	GLOBAL_DASHBOARD_TPP_PAYMENTS = "global-dashboard-tpp-payments",
	GLOBAL_DASHBOARD_TPP_DATA_INPUT = "global-dashboard-tpp-data-input",
	GLOBAL_DASHBOARD_CALENDAR = "global-dashboard-calendar",
	GLOBAL_DASHBOARD_MASTER_DATA = "global-dashboard-master-data"

	//more as needed
}

export enum DeepLinkBaseUrls {
	CPNOW_LOCAL = "http://localhost:8180/",
	CPNOW_DEV = "https:///dev.wezaam.com/",
	CPNOW_UAT = "https://uat.wezaam.com/",
	CPNOW_PROD = "https://admin.wezaam.com/"
}

export enum DeepLinkResourcePaths {
	EMPLOYEE_DATA_PAYGROUP_MASTER_DATA = "client/data-management?"
}
